import { State } from '../state'
import type { BookingflowStateMachine } from '../../bookingflowstatemachine'
import type { Address, BasisType, CustomerType, Goal, Partner, RRDate, Service, Time } from '@raskrask-dk/raskrask-utils'
import {
    IGetMoveBookingData,
    moveActions,
    moveBookingActions,
    MoveBookingActions,
    MoveBookingDependencies,
} from './moveBookingState.types'


const MOVEBOOKING_STATE = 'MOVEBOOKING'
export class MoveBookingState extends State<
    MoveBookingActions,
    typeof MOVEBOOKING_STATE
> {
    public readonly type = MOVEBOOKING_STATE
    private _date: RRDate | undefined
    private _time: Time | undefined

    private _address: Address | undefined = undefined
    private _basisType: BasisType | undefined = undefined
    private _customerType: CustomerType | undefined = undefined
    private _goal: Goal | undefined = undefined
    private _service: Service | undefined = undefined
    private _partner: Partner | undefined = undefined

    constructor(bookingflowStateMachine: BookingflowStateMachine) {
        super(bookingflowStateMachine)
    }

    public unset = (): void => {
        return
    }

    public doAction = (action: MoveBookingActions): MoveBookingState => {
        switch (action.type) {
            case 'SET_DEPENDENCIES':
                this.dependencies = action.isValid()
                    ? (action.data as MoveBookingDependencies)
                    : undefined
                return this
            case 'SET_DATE':
                this._date = action.isValid()
                    ? (action.data as RRDate)
                    : undefined
                return this
            case 'SET_TIME':
                this._time = action.isValid()
                    ? (action.data as Time)
                    : undefined
                return this
            default:
                throw new Error('Unhandled Exception')
        }
    }

    public getActions(): moveActions[] {
        return moveBookingActions.filter((action) =>
            new action(this).isDoable()
        )
    }

    public set dependencies(dependencies: MoveBookingDependencies | undefined) {
        if (!dependencies) return
        this._address = dependencies.address
        this._basisType = dependencies.basisType
        this._customerType = dependencies.customerType
        this._goal = dependencies.goal
        this._service = dependencies.service
        this._partner = dependencies.partner
    }

    public get dependencies(): MoveBookingDependencies | undefined {
        if (
            this._address &&
            this._basisType &&
            this._customerType &&
            this._goal &&
            this._service &&
            this._partner
        ) {
            return {
                address: this._address,
                basisType: this._basisType,
                customerType: this._customerType,
                goal: this._goal,
                service: this._service,
                partner: this._partner,
            }
        } else {
            return undefined
        }
    }

    public get address(): Address | undefined {
        return this._address
    }

    public get basisType(): BasisType | undefined {
        return this._basisType
    }

    public get customerType(): CustomerType | undefined {
        return this._customerType
    }

    public get goal(): Goal | undefined {
        return this._goal
    }

    public get service(): Service | undefined {
        return this._service
    }

    public get partner(): Partner | undefined {
        return this._partner
    }

    public get time(): Time | undefined {
        return this._time
    }

    public get date(): RRDate | undefined {
        return this._date
    }

    public getData(): IGetMoveBookingData {
        return {
            dependencies: this.dependencies,
            date: this._date,
            time: this._time,
        }
    }
}
